import store from '@/vuex/store'
import {isString} from '@/common/validUtil'

/**
 * 按钮级别的权限校验
 * @param value 前端配置的权限，如['bee:member:operator:update']
 * @returns {boolean}
 */
export default function checkPermission(value) {
  if(!value) {
    return false
  }
  const permissions = store.getters && store.getters.permissions

  if (value instanceof Array && value.length > 0) {
    return value.some(permission => permissions.includes(permission))
  }
  if (isString(value)) {
    return permissions.includes(value)
  }

  return false
}

/**
 * 必须拥有所有列出的权限，才显示
 * @param value
 * @returns {boolean}
 */
export function hasAllPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = store.getters && store.getters.permissions

    return value.every(permission => permissions.includes(permission))
  }
  return false
}


/**
 * 判断当前路由是否有权限
 * @param permissions 后端返回的权限集合
 * @param route
 * @returns {boolean}
 */
export function hasPermission(permissions, route) {
  // 如果配置了权限，则需要匹配
  if (route.meta && route.meta.perms && route.meta.perms.length > 0) {
    //如果前端perms包含后端perms返回true
    return permissions.some(permission => route.meta.perms.includes(permission))
  } else {
    // 如果前端未配置权限，直接将路由加入
    return true
  }
}

/**
 * 动态路由过滤
 * @param routes
 * @param permissions 后端返回的权限集合
 * @returns {Array}
 */
export function filterAsyncRoutes(routes, permissions) {
  const res = []

  routes.forEach(route => {
    const tmp = {...route}
    if (hasPermission(permissions, tmp)) {
      // 存在子路由则去判断子路由权限
      if (tmp.children && tmp.children.length > 0) {
        tmp.children = filterAsyncRoutes(tmp.children, permissions)
      }
      res.push(tmp)
    }
  })

  return res
}



// WEBPACK FOOTER //
// ./src/common/permission.js